import React from 'react';
import { IoEllipse } from 'react-icons/io5';
import format from 'date-fns/format';
import { TRACKING_TIMELINE } from '../../interfaces/shipping.interface';
import { titleCase } from '../../utils/common.utils';
import styles from './TrackingShipment.module.scss';

interface Props {
  timeline: TRACKING_TIMELINE;
}

const ShipmentTimeline: React.FC<Props> = ({ timeline }) => (
  <div className={styles.timeline}>
    <IoEllipse className="text-2xl flex-shrink-0" />
    <div className="flex-grow px-4">
      <h4 className="font-medium mb-2">
        {titleCase(timeline.ScanStatus.Incident, true)}
      </h4>
      <p className="text-xs">
        {titleCase(timeline.ScanStatus.Reason, true)}{' '}
        {timeline.Location && `(${titleCase(timeline.Location, true)})`}
      </p>
    </div>
    <div className="text-right flex-shrink-0">
      <div className="font-medium text-green-500">
        {format(new Date(timeline.DateTime), 'hh:mm b')}
      </div>
      <div className="font-medium text-gray-400 text-sm">
        {format(new Date(timeline.DateTime), 'dd MMM, yyyy')}
      </div>
    </div>
  </div>
);

export default ShipmentTimeline;
